import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router";
import { LogoImg } from "../../Constants/Images";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe, faSpinner } from "@fortawesome/free-solid-svg-icons";

import useAuth from "../../Hooks/useAuth";
import CustomButton from "../../Components/Button";
import PasswordInput from "../../Components/PasswordInput";
import ForgotPassword from "./ForgotPasswordForm";
import { AuthActiveFormType } from "../../Constants/Interfaces";
import GoogleLoginBtn from "../../Components/GoogleLoginBtn";

const Login: React.FC = () => {
  const { data, errors, loading, onChange, submitLogin } = useAuth();

  const [activeForm, setActiveForm] = useState<AuthActiveFormType>("Login");

  return (
    <div className="auth-page-wrapper">
      <div className="auth-page-header">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-sm-6">
              <Link to="/">
                <img src={LogoImg} alt="" className="logo-img" />
              </Link>
            </div>

            <div className="col-md-6 col-sm-6">
              <div className="header-auth-links">
                <ul>
                  <li>
                    <FontAwesomeIcon
                      icon={faGlobe}
                      size={"1x"}
                      color="#000000"
                      style={{ marginRight: 5 }}
                    />{" "}
                  </li>

                  <li>
                    <Link to="/signup" className="sign-up">
                      Sign up
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        {activeForm == "Login" && (
          <div className="auth-form-wrapper">
            <div className="auth-headings">
              <h3>Welcome Back</h3>
              <p>Please log in here</p>
            </div>

            <div className="auth-form">
              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  placeholder="Enter your email"
                  value={data.email}
                  onChange={(e) => onChange("email", e.target.value)}
                />
                {errors.email && errors.email !== "" && (
                  <span className="error">{errors.email}</span>
                )}
              </div>

              <div className="form-group">
                <PasswordInput
                  name="password"
                  placeholder="Enter password"
                  value={data.password}
                  onChange={(val) => onChange("password", val)}
                />
                {errors.password && errors.password !== "" && (
                  <span className="error">{errors.password}</span>
                )}
              </div>

              <CustomButton
                isLoading={loading}
                title="Login"
                onClick={submitLogin}
              />

              <span
                className="forgot-link as-link"
                onClick={() => setActiveForm("Forgot Password")}
              >
                Forgot Password
              </span>
            </div>

            <div className="login-with-or-text">
              <span>or</span>
            </div>

            <div className="social-login-btn-wrapper">
              <GoogleLoginBtn />
            </div>

            <div className="have-an-account-links">
              <p>
                Don’t have an account? <Link to="/signup">Sign Up</Link>
              </p>
              <p>
                Question? Need help? <Link to="#">Support Can Help</Link>
              </p>
            </div>
          </div>
        )}

        {activeForm == "Forgot Password" && (
          <ForgotPassword
            changeForm={(form: AuthActiveFormType) => setActiveForm(form)}
          />
        )}
      </div>

      <div className="auth-footer-wrapper">
        <div className="container">
          <ul>
            <li>&copy; 2024 spacii</li>
            <li>
              <Link to="#">Terms of Service</Link>
            </li>
            <li>
              <Link to="#">Privacy Policy</Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Login;
